import CoreTextBlock from './CoreTextBlock';

export { type CoreTextBlockProps } from './CoreTextBlock';
export default CoreTextBlock;
